import { WORKY_WEB_APP_PATHS } from '../../WorkyWebAppPaths';
import { EDIT_WORK_TASK_TEMPLATE_ID_QUERY_KEY } from '../trustvault/worktasks/WorkTaskTemplatePaths';
import { WorkTaskTemplatePurpose } from '../trustvault/worktasks/WorkTaskTemplateInterfaces';

enum TrustVaultHubView {
  HUB = 'HUB',
  WORKER_TASKS = 'WORKER_TASKS',
  CARE_PLANS = 'CARE_PLANS',
  PDF_SETTINGS = 'PDF_SETTINGS',
  ONBOARDING_CHECKLISTS = 'ONBOARDING_CHECKLISTS',
  WORKER_COMPLIANCE_REPORTING = 'WORKER_COMPLIANCE_REPORTING',
}

const TRUST_VAULT_VIEW_QUERY_KEY: string = 'view';
const TRUST_VAULT_WORKER_TASKS_VIEW_VALUE: string = 'worker-tasks';
const TRUST_VAULT_PDF_SETTINGS_VIEW_VALUE: string = 'pdf-settings';
const TRUST_VAULT_CARE_PLANS_VIEW_VALUE: string = 'care-plans';
const TRUST_VAULT_ONBOARDING_CHECKLISTS_VIEW_VALUE: string = 'onboarding-checklists';

const AGENCY_TRUST_VAULT_WORKER_TASKS_PATH: string =
  `${WORKY_WEB_APP_PATHS.agencyTasks}?${TRUST_VAULT_VIEW_QUERY_KEY}=${TRUST_VAULT_WORKER_TASKS_VIEW_VALUE}`;

const AGENCY_TRUST_VAULT_CARE_PLANS_PATH: string =
  `${WORKY_WEB_APP_PATHS.agencyTasks}?${TRUST_VAULT_VIEW_QUERY_KEY}=${TRUST_VAULT_CARE_PLANS_VIEW_VALUE}`;

const AGENCY_TRUST_VAULT_ONBOARDING_CHECKLISTS_PATH: string =
  WORKY_WEB_APP_PATHS.agencyWorkerOnboardingChecklistTemplates;

const AGENCY_TRUST_VAULT_WORKER_COMPLIANCE_REPORTING_PATH: string =
  WORKY_WEB_APP_PATHS.agencyWorkerComplianceReporting;

const CREATE_WORK_TASK_TEMPLATE_PURPOSE_QUERY_KEY: string = 'purpose';

/** Query value for worker onboarding templates (maps to JOBBER_ONBOARDING purpose). */
const WORKER_ONBOARDING_PURPOSE_QUERY_VALUE: string = 'WORKER_ONBOARDING';

const CREATE_CARE_PLAN_TEMPLATE_PATH: string =
  `${WORKY_WEB_APP_PATHS.agencyCreateWorkTaskTemplate}?${CREATE_WORK_TASK_TEMPLATE_PURPOSE_QUERY_KEY}=CARE_PLAN`;

const CREATE_WORKER_ONBOARDING_TEMPLATE_PATH: string =
  `${WORKY_WEB_APP_PATHS.agencyCreateWorkTaskTemplate}?${CREATE_WORK_TASK_TEMPLATE_PURPOSE_QUERY_KEY}=${WORKER_ONBOARDING_PURPOSE_QUERY_VALUE}`;

const buildEditCarePlanTemplatePath = (templateId: string): string => {
  return `${WORKY_WEB_APP_PATHS.agencyCreateWorkTaskTemplate}?${CREATE_WORK_TASK_TEMPLATE_PURPOSE_QUERY_KEY}=CARE_PLAN&${EDIT_WORK_TASK_TEMPLATE_ID_QUERY_KEY}=${encodeURIComponent(templateId)}`;
};

const buildEditWorkerOnboardingTemplatePath = (templateId: string): string => {
  return `${WORKY_WEB_APP_PATHS.agencyCreateWorkTaskTemplate}?${CREATE_WORK_TASK_TEMPLATE_PURPOSE_QUERY_KEY}=${WORKER_ONBOARDING_PURPOSE_QUERY_VALUE}&${EDIT_WORK_TASK_TEMPLATE_ID_QUERY_KEY}=${encodeURIComponent(templateId)}`;
};

const resolveCreateWorkTaskTemplatePurposeFromQuery = (
  search: string
): WorkTaskTemplatePurpose => {
  const params: URLSearchParams = new URLSearchParams(search);
  const purposeValue: string | null = params.get(CREATE_WORK_TASK_TEMPLATE_PURPOSE_QUERY_KEY);
  if (purposeValue === WorkTaskTemplatePurpose.CARE_PLAN || purposeValue === 'CARE_PLAN') {
    return WorkTaskTemplatePurpose.CARE_PLAN;
  }
  if (
    purposeValue === WORKER_ONBOARDING_PURPOSE_QUERY_VALUE
    || purposeValue === WorkTaskTemplatePurpose.JOBBER_ONBOARDING
    || purposeValue === 'JOBBER_ONBOARDING'
  ) {
    return WorkTaskTemplatePurpose.JOBBER_ONBOARDING;
  }
  return WorkTaskTemplatePurpose.WORK_TASK;
};

interface TrustVaultHubSectionConfig {
  readonly view: TrustVaultHubView;
  readonly title: string;
  readonly description: string;
}

export {
  TrustVaultHubView,
  TrustVaultHubSectionConfig,
  TRUST_VAULT_VIEW_QUERY_KEY,
  TRUST_VAULT_WORKER_TASKS_VIEW_VALUE,
  TRUST_VAULT_PDF_SETTINGS_VIEW_VALUE,
  TRUST_VAULT_CARE_PLANS_VIEW_VALUE,
  TRUST_VAULT_ONBOARDING_CHECKLISTS_VIEW_VALUE,
  AGENCY_TRUST_VAULT_WORKER_TASKS_PATH,
  AGENCY_TRUST_VAULT_CARE_PLANS_PATH,
  AGENCY_TRUST_VAULT_ONBOARDING_CHECKLISTS_PATH,
  AGENCY_TRUST_VAULT_WORKER_COMPLIANCE_REPORTING_PATH,
  CREATE_WORK_TASK_TEMPLATE_PURPOSE_QUERY_KEY,
  WORKER_ONBOARDING_PURPOSE_QUERY_VALUE,
  CREATE_CARE_PLAN_TEMPLATE_PATH,
  CREATE_WORKER_ONBOARDING_TEMPLATE_PATH,
  buildEditCarePlanTemplatePath,
  buildEditWorkerOnboardingTemplatePath,
  resolveCreateWorkTaskTemplatePurposeFromQuery,
};
